import { CSSProperties } from 'react'

import { stegaClean } from 'next-sanity'
import { PortableTextComponentProps } from 'next-sanity'

import type { SpacingSize } from '@/app/config/spacingStyles'

export type SpacingObjectValue = {
  _type: 'spacing'
  /** Base size (required in Sanity) */
  default: SpacingSize
  /** Optional md override */
  md?: SpacingSize
  /** Optional lg override */
  lg?: SpacingSize
}

const cssVarForSize = (size?: SpacingSize) => (size ? `var(--spacing-${size})` : undefined)

export const Spacing = (props: PortableTextComponentProps<SpacingObjectValue>) => {
  const { value } = props

  // Clean stega encoding from values for use in CSS variables
  const base = stegaClean(value.default)
  const md = value.md ? stegaClean(value.md) : undefined
  const lg = value.lg ? stegaClean(value.lg) : undefined

  const style = {
    // these are *CSS custom properties*, consumed by CSS below
    '--spacing-default-var': cssVarForSize(base),
    '--spacing-md-var': cssVarForSize(md) || cssVarForSize(base),
    '--spacing-lg-var': cssVarForSize(lg) || cssVarForSize(md) || cssVarForSize(base),
  } as CSSProperties

  return <div className="spacing-block" style={style} aria-hidden="true" />
}
